module.exports = __webpack_public_path__ + "static/media/bar-code.099b55e6.svg";